// Navbar.jsx
import React from "react";
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

import { logo } from "../utils/constants";
import { SearchBar } from "./";

const Navbar = () => (
  <Stack direction="row" alignItems="center" p={2} sx={{ position:  "sticky", 
  background: 'linear-gradient(to bottom, rgb(200, 20, 60), rgb(150, 20, 20))', 
  background: 'linear-gradient(to bottom, rgb(170, 15, 50), rgb(130, 15, 15))',  
  top: 0, justifyContent: "space-between" }}>
    <Link to="/" style={{ display: "flex", alignItems: "center", fontFamily: "Verdana, sans-serif", fontStyle: "italic", fontWeight: "bold", fontSize: "25px", letterSpacing: "1px", color: "white", textShadow: "-1px 1px 0 rgba(10, 10, 10), 1px 1px 0 rgba(10, 10, 10), 1px -1px 0 rgba(10, 10, 10), -1px -1px 0 rgba(10, 10, 10)"  }}>
      <div style={{ display: "flex", alignItems: "center" }}>

        <div style={{ marginRight: "10px" }}>
          <img src={logo} alt="SoccerTube" height={45} />
        </div>
        Soccer<span style={{ color: "rgb(200,80,80)" }}>Tube</span>
        </div>

    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar; 

// Navbar.jsx